var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CartInfoCard',{attrs:{"infoValue":_vm.value,"text":_vm.text,"icon":`/services-icons/${_vm.serviceImage}.svg`,"editable":_vm.editable,"isCheckout":_vm.isCheckout,"small":_vm.small},on:{"edit":_vm.edit}})
}
var staticRenderFns = []

export { render, staticRenderFns }